<header [class]="
    isAuthenticated()
      ? 'header-logout primary-bg'
      : 'header-login primary-bg'
  ">
  <div class="container-header">
    <div class="logo-menu">
      @if (isAuthenticated() && userData?.logo) {
      <img [src]="userData?.logo" alt="Client Logo" />
      } @else if (clientsFromUserScreen?.logo) {
      <img [src]="clientsFromUserScreen?.logo" alt="Client Logo" class="logo-header" />
      }

      <nav class="nav-header">
        @if (isAuthenticated()) {
        <ul class="container-menu">
          <li (click)="navigateToClasses()" *hasRole="[Role.SUPER_ADMIN, Role.ADMIN]">
            <p class="link-header">Classes</p>
          </li>
          <li (click)="navigateToProjects()" *hasRole="[Role.SUPER_ADMIN, Role.ADMIN]">
            <p class="link-header">Projects</p>
          </li>
          <li (click)="navigateToProducts()" *hasRole="[Role.SUPER_ADMIN, Role.ADMIN]">
            <p class="link-header">Products</p>
          </li>
          <li (click)="navigateToTraining()">
            <p class="link-header">Training</p>
          </li>
          <li (click)="navigateToImageBrowser()">
            <p class="link-header">Image Browser</p>
          </li>
          <li class="li-logout" (click)="logout()">
            <mat-icon class="icon-logout">exit_to_app</mat-icon>
          </li>
        </ul>
        <div class="container-menu-mobile">
          <mat-icon style="cursor: pointer" [matMenuTriggerFor]="menu">menu</mat-icon>
          <mat-menu #menu="matMenu">
            @if (isAuthenticated()) {
            <button mat-menu-item (click)="navigateToClasses()">
              Classes
            </button>
            <button mat-menu-item (click)="navigateToProjects()">
              Projects
            </button>
            <button mat-menu-item (click)="navigateToTraining()">
              Training
            </button>
            <button mat-menu-item (click)="navigateToImageBrowser()">
              Image Browser
            </button>
            <button class="button-logout" mat-menu-item (click)="logout()">
              <mat-icon>exit_to_app</mat-icon>
              <p>Sign out</p>
            </button>
            }
          </mat-menu>
        </div>
        }
        @if (!isAuthenticated() && !hideMenuForUrl) {
        <ul class="menu-logout">
          <li>
            <p (click)="navigateToDisclaimer()" class="link-header">
              Disclamer
            </p>
          </li>
          <!-- <li>
                <button (click)="navigateToRegister()" class="link-header button-register primary-bg text-color">
                  Sign Up
                </button>
              </li> -->
          <li>
            <button (click)="navigateToLogin()" class="link-header button-register primary-bg text-color">
              Sign In
            </button>
          </li>
        </ul>
        }
      </nav>
    </div>

    @if (isAuthenticated()) {
    <div class="sub-header">
      <div class="client-data">
        <p>Demo for <span class="client-name">{{userData?.clientName}}</span></p>
        @if (!hideProjectDataForUrl) {
        <mat-form-field *hasRole="[Role.ADMIN, Role.SUPERVISOR, Role.SUPER_ADMIN]">
          <mat-select [(value)]="selected" (selectionChange)="onProjectChange($event)" class="select-custom-projects">
            @for (project of projects; track project) {
            <mat-option class="option-custom" [value]="project">{{
              project.name
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-icon class="goToClassyfcationDetection" [matMenuTriggerFor]="linkMenu">link</mat-icon>
        <mat-menu #linkMenu="matMenu">
          <button mat-menu-item (click)="goToClassificationDetection()">
            <mat-icon>open_in_browser</mat-icon>
            <span>Go to Classification</span>
          </button>
          <button mat-menu-item (click)="openInNewTab()">
            <mat-icon>open_in_new</mat-icon>
            <span>Open in New Tab</span>
          </button>
          <button mat-menu-item (click)="generateQRCode()">
            <mat-icon>qr_code</mat-icon>
            <span>Show QR Code</span>
          </button>
        </mat-menu>
        }
      </div>
      <p class="role">{{ userData?.role }}</p>
    </div>
    }

    @if (!isAuthenticated()) {
    <div class="sub-header">
      <div class="client-data">
        <p>Demo for <span class="client-name">{{clientsFromUserScreen?.name}}</span></p>
      </div>
    </div>
    }
  </div>
</header>

<!-- QR Code Modal -->
@if (showQrCode) {
<div class="qr-overlay" (click)="closeQrCode()">
  <div class="qr-modal" (click)="$event.stopPropagation()">
    <div class="qr-header">
      <h3>QR Code - Classification Page</h3>
      <mat-icon class="close-btn" (click)="closeQrCode()">close</mat-icon>
    </div>
    <div class="qr-content">
      <img [src]="qrCodeDataUrl" alt="QR Code" class="qr-image">
      <p class="qr-description">Scan this QR code to access the classification page on your mobile device</p>
    </div>
  </div>
</div>
}
